import { render } from "./Resources.vue?vue&type=template&id=892f4bac&scoped=true"
import script from "./Resources.vue?vue&type=script&lang=js"
export * from "./Resources.vue?vue&type=script&lang=js"

import "./Resources.vue?vue&type=style&index=0&id=892f4bac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\freemath\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-892f4bac"]])

export default __exports__